// extracted by mini-css-extract-plugin
export const sectionIconContent = "iconContent-module--sectionIconContent--2ZTDC";
export const contentTable = "iconContent-module--contentTable--14810";
export const imgCol = "iconContent-module--imgCol--kTtXD";
export const contentCol = "iconContent-module--contentCol--2og1x";
export const contentWrap = "iconContent-module--contentWrap--2NwRX";